import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex flex-column align-items-center justify-content-center pt-3 pb-3" }
const _hoisted_2 = { class: "align-items-center flex justify-content-between" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3 border-solid border-1 surface-border" }, null, -1)
const _hoisted_6 = { class: "flex flex-wrap" }
const _hoisted_7 = { class: "w-12 md:w-6 lg:w-6 xl:w-6 p-1" }
const _hoisted_8 = {
  class: "w-full mt-4",
  style: {"position":"relative"}
}
const _hoisted_9 = { class: "field mb-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  class: "mb-1",
  for: "res-req-order"
}, "Objednávka", -1)
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", {
  class: "flex justify-content-center align-items-center",
  style: {"width":"1.8rem"}
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    class: "p-icon p-button-icon"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M7.01744 10.398C6.91269 10.3985 6.8089 10.378 6.71215 10.3379C6.61541 10.2977 6.52766 10.2386 6.45405 10.1641L1.13907 4.84913C1.03306 4.69404 0.985221 4.5065 1.00399 4.31958C1.02276 4.13266 1.10693 3.95838 1.24166 3.82747C1.37639 3.69655 1.55301 3.61742 1.74039 3.60402C1.92777 3.59062 2.11386 3.64382 2.26584 3.75424L7.01744 8.47394L11.769 3.75424C11.9189 3.65709 12.097 3.61306 12.2748 3.62921C12.4527 3.64535 12.6199 3.72073 12.7498 3.84328C12.8797 3.96582 12.9647 4.12842 12.9912 4.30502C13.0177 4.48162 12.9841 4.662 12.8958 4.81724L7.58083 10.1322C7.50996 10.2125 7.42344 10.2775 7.32656 10.3232C7.22968 10.3689 7.12449 10.3944 7.01744 10.398Z",
      fill: "currentColor"
    })
  ])
], -1)
const _hoisted_14 = {
  key: 0,
  class: "card",
  style: {"z-index":"10","position":"absolute","top":"30px","left":"1px","min-width":"20rem","transform-origin":"center top","margin-top":"2px"}
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_16 = { class: "field mb-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  class: "mb-1",
  for: "res-req-customer"
}, "Zákazník", -1)
const _hoisted_18 = { class: "field mb-1" }
const _hoisted_19 = {
  class: "flex align-items-center justify-content-between",
  style: {"margin-bottom":"0rem"}
}
const _hoisted_20 = { class: "mb-1" }
const _hoisted_21 = { class: "flex align-items-center justify-content-right" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", {
  for: "imitation",
  class: "mr-2 mb-1"
}, "Imitácia dreva", -1)
const _hoisted_23 = {
  key: 0,
  class: "flex align-items-center"
}
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "flex align-items-center" }
const _hoisted_26 = { class: "w-12 md:w-6 lg:w-6 xl:w-6 p-1" }
const _hoisted_27 = { class: "w-full ml-0 mr-0" }
const _hoisted_28 = { class: "grid ml-0 mr-0" }
const _hoisted_29 = { class: "col-10 pl-0 pr-1 pb-0" }
const _hoisted_30 = { class: "field mb-1" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", {
  class: "mb-1",
  for: "res-req-product"
}, "Produkt", -1)
const _hoisted_32 = {
  key: 0,
  class: ""
}
const _hoisted_33 = { class: "text-sm" }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { class: "text-sm" }
const _hoisted_36 = { class: "text-sm" }
const _hoisted_37 = { class: "col-2 pr-0 pl-0 pb-0" }
const _hoisted_38 = { class: "field mb-1" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", {
  class: "mb-1",
  for: "product-number"
}, "Počet", -1)
const _hoisted_40 = {
  key: 0,
  class: "field mt-2"
}
const _hoisted_41 = {
  class: "flex align-items-center justify-content-between",
  style: {"margin-bottom":"0rem"}
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", { class: "mb-1" }, "Farba", -1)
const _hoisted_43 = { class: "flex align-items-center justify-content-right" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", {
  for: "imitation",
  class: "mr-2 mb-1"
}, "Imitácia dreva", -1)
const _hoisted_45 = {
  key: 0,
  class: "flex align-items-center"
}
const _hoisted_46 = { key: 1 }
const _hoisted_47 = { class: "flex align-items-center" }
const _hoisted_48 = { class: "flex justify-content-center mb-1" }
const _hoisted_49 = {
  key: 0,
  class: "mini-image-container"
}
const _hoisted_50 = ["src"]
const _hoisted_51 = {
  key: 1,
  class: "image-container placeholder"
}
const _hoisted_52 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-image placeholder-icon" }, null, -1)
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = { class: "flex justify-content-center" }
const _hoisted_55 = { class: "w-12 p-0" }
const _hoisted_56 = { class: "w-full ml-0 mr-0" }
const _hoisted_57 = {
  key: 0,
  class: "w-full pt-0 pl-0 pr-0 pb-0 flex justify-content-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimevueTag = _resolveComponent("PrimevueTag")!
  const _component_PrimevueButton = _resolveComponent("PrimevueButton")!
  const _component_InputIcon = _resolveComponent("InputIcon")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_IconField = _resolveComponent("IconField")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_PrimevueCheckbox = _resolveComponent("PrimevueCheckbox")!
  const _component_PrimevueSelect = _resolveComponent("PrimevueSelect")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Fieldset = _resolveComponent("Fieldset")!
  const _component_RequestProfileReserveList = _resolveComponent("RequestProfileReserveList")!
  const _component_PrimevueCard = _resolveComponent("PrimevueCard")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PrimevueCard, { class: "sm:w-12 md:w-11 lg:w-11 xl:w-8 mb-2" }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (this.routeParams.typ == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, "ŽIADOSŤ O REZERVÁCIU"))
            : _createCommentVNode("", true),
          (this.routeParams.typ == 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, "ŽIADOSŤ O PRESTRIEKANIE"))
            : _createCommentVNode("", true),
          _createVNode(_component_PrimevueTag, {
            class: "p-2 ml-1 font-medium text-base justify-content-center",
            value: $data.reservationRequest.status,
            severity: $data.reservationRequest.status == 'Nová' ? 'primary' : ($data.reservationRequest.status == 'Rozpracovaná' ? 'warning' : 'success')
          }, null, 8, ["value", "severity"])
        ])
      ]),
      subtitle: _withCtx(() => [
        _hoisted_5
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(_component_PrimevueButton, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.initOrders())),
                  disabled: !(this.routeParams.resReqId == '0'),
                  style: {"height":"2rem"},
                  class: "flex justify-content-between w-full",
                  outlined: "",
                  id: "res-req-order"
                }, {
                  default: _withCtx(() => [
                    ($data.selectedOrder)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(this.selectedOrder.orderCode), 1))
                      : _createCommentVNode("", true),
                    (!$data.selectedOrder)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Vyber objednávku"))
                      : _createCommentVNode("", true),
                    _hoisted_13
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                ($data.visibleSelect)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createVNode(_component_IconField, { iconPosition: "left" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_InputIcon, null, {
                            default: _withCtx(() => [
                              _hoisted_15
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_InputText, {
                            modelValue: $data.orderFilters['global'].value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.orderFilters['global'].value) = $event)),
                            placeholder: "Vyhľadať",
                            onInput: _cache[2] || (_cache[2] = ($event: any) => ($options.onOrderFilter()))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_DataTable, {
                        lazy: "",
                        paginator: "",
                        rows: $data.selectParams.rows,
                        onPage: _cache[3] || (_cache[3] = ($event: any) => ($options.onOrderPage($event))),
                        first: $data.selectParams.first,
                        loading: $data.selectLoading,
                        totalRecords: $data.selectParams.totalRecords,
                        dataKey: "id",
                        value: $data.orderOptions,
                        scrollHeight: `${200}px`,
                        virtualScrollerOptions: { itemSize: 40 },
                        stripedRows: "",
                        "row-hover": "",
                        scrollable: "",
                        selection: $data.selectedOrder,
                        "onUpdate:selection": _cache[4] || (_cache[4] = ($event: any) => (($data.selectedOrder) = $event)),
                        selectionMode: "single",
                        metaKeySelection: false,
                        onRowSelect: _cache[5] || (_cache[5] = ($event: any) => ($options.selectOrder())),
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Column, {
                            header: "ID",
                            field: "orderCode",
                            style: {"width":"5%"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Meno",
                            field: "customer.lastName",
                            style: {"width":"50%"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Obec",
                            field: "customer.city",
                            style: {"width":"45%"}
                          })
                        ]),
                        _: 1
                      }, 8, ["rows", "first", "loading", "totalRecords", "value", "selection"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createVNode(_component_InputText, {
                  class: "w-full",
                  disabled: "",
                  placeholder: $data.reservationRequest.order.customerLastName +' '+$data.reservationRequest.order.customerFirstName,
                  type: "text",
                  name: "res-req-customer",
                  id: "res-req-customer"
                }, null, 8, ["placeholder"])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("span", _hoisted_20, _toDisplayString(this.routeParams.typ == 1 ? 'Farba' : 'Nová farba'), 1),
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createVNode(_component_PrimevueCheckbox, {
                      disabled: !$data.selectedOrder || !(this.routeParams.resReqId == '0'),
                      modelValue: $data.imitation,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($data.imitation) = $event)),
                      inputId: "imitation",
                      name: "imitation",
                      binary: true,
                      onChange: _cache[7] || (_cache[7] = ($event: any) => ($options.setColors()))
                    }, null, 8, ["disabled", "modelValue"])
                  ])
                ]),
                _createVNode(_component_PrimevueSelect, {
                  id: "req-color",
                  disabled: !$data.selectedOrder || !(this.routeParams.resReqId == '0'),
                  onChange: _cache[8] || (_cache[8] = ($event: any) => (this.routeParams.typ == 1 ? $options.filterProducts($data.selectedColor.id) : null)),
                  modelValue: $data.selectedColor,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($data.selectedColor) = $event)),
                  options: $data.colors,
                  optionLabel: "code",
                  placeholder: "Vyber farbu",
                  class: _normalizeClass(["w-full", `${$setup.v$.selectedColor.$error ? 'bg-red-200' : ''}`]),
                  invalid: $setup.v$.selectedColor.$error
                }, {
                  value: _withCtx((slotProps) => [
                    (slotProps.value.id != 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          _createElementVNode("div", {
                            class: "color-box mr-2",
                            style: _normalizeStyle({ backgroundColor: slotProps.value.colorHash })
                          }, null, 4),
                          _createElementVNode("div", null, _toDisplayString(slotProps.value.code), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(slotProps.placeholder), 1))
                  ]),
                  option: _withCtx((slotProps) => [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", {
                        class: "color-box mr-2",
                        style: _normalizeStyle({ backgroundColor: slotProps.option.colorHash })
                      }, null, 4),
                      _createElementVNode("div", null, _toDisplayString(slotProps.option.code), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["disabled", "modelValue", "options", "class", "invalid"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.selectedColor.$errors, (error, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "text-sm font-italic text-red-400"
                  }, _toDisplayString(error.$message), 1))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_component_Fieldset, {
              legend: this.routeParams.typ == 1 ? 'Vyžiadanie rezervácie profilov' : 'Vyžiadanie prestriekania profilov',
              class: ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _hoisted_31,
                        _createVNode(_component_PrimevueSelect, {
                          id: "res-req-product",
                          disabled: !$data.selectedColor.code || !($data.store.user.admin === true || $data.store.user.department.id == 3),
                          modelValue: $data.selectedProduct,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($data.selectedProduct) = $event)),
                          filter: "",
                          options: $data.productOptions,
                          optionLabel: "product.code",
                          placeholder: "Vyber produkt",
                          class: _normalizeClass(["w-full", `${$setup.v$.selectedProduct.product.code.$error ? 'bg-red-200' : ''}`]),
                          invalid: $setup.v$.selectedProduct.product.code.$error
                        }, {
                          value: _withCtx((slotProps) => [
                            (slotProps.value.id != 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                  _createElementVNode("div", _hoisted_33, _toDisplayString(slotProps.value.product.code) + " - " + _toDisplayString(slotProps.value.product.name.length > 26 ? slotProps.value.product.name.slice(0, 26) + '...' : slotProps.value.product.name) + " - " + _toDisplayString(slotProps.value.numberOfItem), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_34, [
                                  _createElementVNode("div", _hoisted_35, _toDisplayString(slotProps.placeholder), 1)
                                ]))
                          ]),
                          option: _withCtx((slotProps) => [
                            _createElementVNode("div", _hoisted_36, [
                              _createElementVNode("div", null, _toDisplayString(slotProps.option.product.code) + " - " + _toDisplayString(slotProps.option.product.name) + " - " + _toDisplayString(slotProps.option.numberOfItem), 1)
                            ])
                          ]),
                          _: 1
                        }, 8, ["disabled", "modelValue", "options", "class", "invalid"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _hoisted_39,
                        _createVNode(_component_InputNumber, {
                          inputId: "product-number",
                          useGrouping: false,
                          disabled: !($data.selectedProduct.id > 0),
                          modelValue: $data.numberOfProd,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($data.numberOfProd) = $event)),
                          name: "product-number",
                          id: "product-number",
                          inputClass: `${$setup.v$.numberOfProd.$error ? 'text-sm bg-red-200 w-full' : 'text-sm w-full'}`,
                          invalid: $setup.v$.numberOfProd.$error
                        }, null, 8, ["disabled", "modelValue", "inputClass", "invalid"])
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.numberOfProd.$errors, (error, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "text-sm font-italic text-red-400"
                      }, _toDisplayString(error.$message), 1))
                    }), 128))
                  ]),
                  false
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          _hoisted_42,
                          _createElementVNode("div", _hoisted_43, [
                            _hoisted_44,
                            _createVNode(_component_PrimevueCheckbox, {
                              disabled: !($data.selectedProduct.id > 0),
                              modelValue: $data.imitation,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($data.imitation) = $event)),
                              inputId: "imitation",
                              name: "imitation",
                              binary: true,
                              onChange: _cache[13] || (_cache[13] = ($event: any) => ($options.setColors()))
                            }, null, 8, ["disabled", "modelValue"])
                          ])
                        ]),
                        _createVNode(_component_PrimevueSelect, {
                          id: "req-spray-color",
                          disabled: !($data.selectedProduct.id > 0),
                          onChange: _cache[14] || (_cache[14] = ($event: any) => ($options.filterProducts($data.selectedColor.id))),
                          modelValue: $data.selectedColor,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($data.selectedColor) = $event)),
                          options: $data.colors,
                          optionLabel: "code",
                          placeholder: "Vyber farbu",
                          class: _normalizeClass(["w-full", `${$setup.v$.selectedColor.$error ? 'bg-red-200' : ''}`]),
                          invalid: $setup.v$.selectedColor.$error
                        }, {
                          value: _withCtx((slotProps) => [
                            (slotProps.value.id != 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                  _createElementVNode("div", {
                                    class: "color-box mr-2",
                                    style: _normalizeStyle({ backgroundColor: slotProps.value.colorHash })
                                  }, null, 4),
                                  _createElementVNode("div", null, _toDisplayString(slotProps.value.code), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(slotProps.placeholder), 1))
                          ]),
                          option: _withCtx((slotProps) => [
                            _createElementVNode("div", _hoisted_47, [
                              _createElementVNode("div", {
                                class: "color-box mr-2",
                                style: _normalizeStyle({ backgroundColor: slotProps.option.colorHash })
                              }, null, 4),
                              _createElementVNode("div", null, _toDisplayString(slotProps.option.code), 1)
                            ])
                          ]),
                          _: 1
                        }, 8, ["disabled", "modelValue", "options", "class", "invalid"]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.selectedColor.$errors, (error, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "text-sm font-italic text-red-400"
                          }, _toDisplayString(error.$message), 1))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_48, [
                    ($data.selectedProduct.product.image)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                          _createElementVNode("img", {
                            src: $data.selectedProduct.product.image,
                            style: _normalizeStyle(`${this.imageHeight >= this.imageWidth ? 'height:180px;' : 'width:260px;'}`),
                            onLoad: _cache[16] || (_cache[16] = ($event: any) => ($options.checkImageSize($event))),
                            alt: "Preview Image",
                            class: ""
                          }, null, 44, _hoisted_50)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_51, _hoisted_53))
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    _createVNode(_component_PrimevueButton, {
                      onClick: _cache[17] || (_cache[17] = ($event: any) => ($options.addProduct())),
                      label: this.routeParams.typ == 1 ? 'Vyžiadať rezerváciu profilu' : 'Vyžiadať prestriekanie profilu',
                      disabled: !($data.selectedProduct.id != 0),
                      severity: "success",
                      icon: "pi pi-plus-circle",
                      text: "",
                      raised: "",
                      class: "mt-1 w-11 md:w-11 lg:w-11 xl:w-10 uppercase"
                    }, null, 8, ["label", "disabled"])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["legend"])
          ])
        ]),
        _createElementVNode("div", _hoisted_55, [
          _createVNode(_component_Fieldset, {
            legend: this.routeParams.typ == 1 ? 'Vyžiadané rezervácie profilov' : 'Vyžiadané prestriekania profilov',
            class: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_56, [
                _createVNode(_component_RequestProfileReserveList, {
                  typ: this.routeParams.typ,
                  resReqId: this.routeParams.resReqId,
                  onDeleteResReq: $options.deleteResReq
                }, null, 8, ["typ", "resReqId", "onDeleteResReq"])
              ])
            ]),
            _: 1
          }, 8, ["legend"])
        ]),
        (this.routeParams.resReqId > 0 && ($data.store.user.admin === true || $data.store.user.department.id == 3))
          ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
              _withDirectives(_createVNode(_component_PrimevueButton, {
                onClick: _cache[18] || (_cache[18] = ($event: any) => ($options.confirmDelete())),
                label: this.routeParams.typ == 1 ? 'Odstrániť vyžiadanú rezerváciu' : 'Odstrániť vyžiadané prestriekanie',
                severity: "danger",
                icon: "pi pi-trash",
                text: "",
                raised: "",
                class: "w-11 md:w-7 lg:w-6 xl:w-5 mt-2 mb-2 uppercase"
              }, null, 8, ["label"]), [
                [
                  _directive_tooltip,
                  { value: `${!this.deleteIsPossible ? 
                  (this.routeParams.typ == 1 ? 'Vyžiadanú rezerváciu je možné odstrániť iba ak boli odstránené všetky vyžiadané rezervácie produktov' : 
                    'Vyžiadané prestriekanie je možné odstrániť iba ak boli odstránené všetky vyžiadané prestriekania produktov' ) : ''}` },
                  void 0,
                  { top: true }
                ]
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_ConfirmDialog)
  ]))
}